define('NoticeMessageView',[
    'backbone',
    'jquery',
    'MessageView',
    'InternalLinkView',
    'template!blocks/messages/notice',
    'app',
    'LocalStorage',
    'UI'
], function (Backbone, $, MessageView,
             InternalLinkView,
             NoticeTemplate,
             app,
             LocalStorage,
             UI
) {

    var TRANSITION_DURATION = 500;
    var LINE_HEIGHT_MOBILE = 16;

    return MessageView.extend({
        render: function () {
            var view = this;
            view.$el
                .html(NoticeTemplate(view))
                .css({
                    'position': 'absolute',
                    'left': '50%',
                    'transform': 'translateX(-50%)'
                });
            view.show();
        },
        show: function () {
            var view = this;

            $('li[data-link="Store"]').append(view.$el);
            var styles = view.computeNoticeCSS();
            view.$('.notice')
                .parent()
                .css({'bottom': styles.bottom, 'height': styles.height});

            view.$('.notice__content')
                .css({
                    'height': styles.contentHeight
                })

            view.$('.icon-cross').on('click', function () {
                view.dismiss();
            })

            view.$el.on('click',function(e){
                var link;
                if(!!(link = view.$('a').get(0))){
                    if(e.target !== link){
                        view.$('a').click();
                    }
                    view.dismiss();
                }
                return false;
            });
            InternalLinkView.initializeLinksOfView(view);
        },
        computeNoticeCSS: function () {
            var view = this,
                noticeContent = view.$('.notice__content'),
                linesCount = noticeContent.linesCount(),
                noticeBottom = 0,
                noticeHeight,
                noticeContentHeight;

            if (linesCount !== 1) {
                if (app.isDesktop()) {
                    noticeBottom = linesCount * -10;
                }else {
                    noticeHeight = linesCount * 6;
                    noticeBottom = - noticeHeight;
                    noticeContentHeight = linesCount * LINE_HEIGHT_MOBILE;
                }
            }

            return {
                bottom: noticeBottom,
                height: noticeHeight || null,
                contentHeight:  noticeContentHeight|| null
            }
        },
        hide: function () {
            var view = this;
            view.$el.children().addClass('hide');
            setTimeout(function () {
                view.$el.remove();
            }, TRANSITION_DURATION)
        },
    });
});
